export enum NotificationState {
  NONE = 'none',
  CP_CREDITED = 'cp_credited',
  CLAIM_BONUS = 'claim_bonus',
  BONUS_ACTIVATED = 'bonus_activated',
  BONUS_EXPIRED = 'bonus_expired',
  CASH_BONUS_CREDITED = 'cash_bonus_credited',
  CASH_BONUS_EXPIRED = 'cash_bonus_expired',
  CANCELLED = 'cancelled',
  BONUSES_DISABLED = 'bonuses_disabled',
  SUCCESS = 'success',
}
